import React, { Component } from "react";
import { connect } from "react-redux";
import xss from "xss";

import { panelActions, messageActions, pageActions } from "../actions";
import { emptyBasketError } from "../utils/enums/CONSTANTS";
import { CloseIcon, ShoppingCartIcon, SearchIcon } from "../utils/components/icons";
import { scrollToTop } from "../utils/functions";

class Basket extends Component {
  constructor(props) {
    super(props);
    this.handleShowBasket = this.handleShowBasket.bind(this);
    this.handleQuery = this.handleQuery.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }
  handleQuery(e) {
    this.props.dispatch(panelActions.setQuery(xss(e.target.value)));
  }
  handleClear() {
    this.props.dispatch(panelActions.setQuery(""));
  }
  handleShowBasket() {
    if (this.props.basketStorage.numItems() > 0) {
      scrollToTop();
      this.props.dispatch(pageActions.setCartPage());
    } else {
      this.props.dispatch(
        messageActions.showMessage(
          this.props.configStorage.getHtmlId(),
          ".ser-basketanchor",
          emptyBasketError
        )
      );
    }
  }

  render() {
    let basket = this.props.basketStorage;
    let lightShop = this.props.configStorage.isLightShop();
    return (
      <div className="ser-searchbasket ser-items">
        <div className="ser-basketanchor ser-iblock">
          <button type="button"
            className="btn-link"
            onClick={this.handleShowBasket}
            disabled={lightShop}
            aria-live="polite"
            aria-label="Gehe zum Warenkorb"
          >
            {!lightShop ?
              <>
                <ShoppingCartIcon></ShoppingCartIcon>
                <span className="ser-baskettext">Artikel: </span>
                <span className="ser-basketcount">{basket.items.length}</span>
                <span className="ser-baskettext"> (={" "}
                  <span>{basket.sum.toEuro()}</span>)
                </span>
              </> : null
            }
          </button>
        </div>
        <section className="ser-searchpanel ser-iblock ser-panel" aria-label="Suche">
          <SearchIcon className="ser-search"></SearchIcon>
          <input
            name="suchFeld"
            type="text"
            className="ser-search"
            value={this.props.panelStorage.getQuery()}
            onChange={this.handleQuery}
            placeholder="Was suchen Sie?"
            titel="Suchfeld"
          />
          <button type="button"
            className={
              "ser-search-clear btn-link" +
              (this.props.panelStorage.isQueryActive() ? "" : " ser-hidden")
            }
            onClick={this.handleClear}
            title="Suche löschen"
          >
            <CloseIcon />
          </button>
        </section>
      </div>
    );
  }
}

export default connect(store => {
  return {
    basketStorage: store.basketStorage,
    panelStorage: store.panelStorage,
    configStorage: store.configStorage,
  };
})(Basket);
